"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPS_TYPE_ID_MAPPING = exports.CONFERENCING_APPS = exports.CAL_VIDEO_TYPE = exports.CAL_VIDEO = exports.OFFICE_365_VIDEO_TYPE = exports.OFFICE_365_VIDEO = exports.ZOOM_TYPE = exports.ZOOM = exports.GOOGLE_MEET_ID = exports.GOOGLE_MEET_TYPE = exports.GOOGLE_MEET = exports.CREDENTIAL_CALENDARS = exports.CALENDARS = exports.APPLE_CALENDAR_ID = exports.ICS_CALENDAR_TYPE = exports.APPLE_CALENDAR_TYPE = exports.ICS_CALENDAR_ID = exports.ICS_CALENDAR = exports.APPLE_CALENDAR = exports.OFFICE_365_CALENDAR = exports.GOOGLE_CALENDAR = exports.OFFICE_365_CALENDAR_ID = exports.OFFICE_365_CALENDAR_TYPE = exports.GOOGLE_CALENDAR_ID = exports.GOOGLE_CALENDAR_TYPE = void 0;
exports.GOOGLE_CALENDAR_TYPE = "google_calendar";
exports.GOOGLE_CALENDAR_ID = "google-calendar";
exports.OFFICE_365_CALENDAR_TYPE = "office365_calendar";
exports.OFFICE_365_CALENDAR_ID = "office365-calendar";
exports.GOOGLE_CALENDAR = "google";
exports.OFFICE_365_CALENDAR = "office365";
exports.APPLE_CALENDAR = "apple";
exports.ICS_CALENDAR = "ics-feed";
exports.ICS_CALENDAR_ID = "ics-feed";
exports.APPLE_CALENDAR_TYPE = "apple_calendar";
exports.ICS_CALENDAR_TYPE = "ics-feed_calendar";
exports.APPLE_CALENDAR_ID = "apple-calendar";
exports.CALENDARS = [exports.GOOGLE_CALENDAR, exports.OFFICE_365_CALENDAR, exports.APPLE_CALENDAR];
exports.CREDENTIAL_CALENDARS = [exports.APPLE_CALENDAR];
exports.GOOGLE_MEET = "google-meet";
exports.GOOGLE_MEET_TYPE = "google_video";
exports.GOOGLE_MEET_ID = "google-meet";
exports.ZOOM = "zoom";
exports.ZOOM_TYPE = "zoom_video";
exports.OFFICE_365_VIDEO = "msteams";
exports.OFFICE_365_VIDEO_TYPE = "office365_video";
exports.CAL_VIDEO = "daily-video";
exports.CAL_VIDEO_TYPE = "daily_video";
exports.CONFERENCING_APPS = [exports.GOOGLE_MEET, exports.ZOOM, exports.OFFICE_365_VIDEO];
exports.APPS_TYPE_ID_MAPPING = (_a = {},
    _a[exports.GOOGLE_CALENDAR_TYPE] = exports.GOOGLE_CALENDAR_ID,
    _a[exports.OFFICE_365_CALENDAR_TYPE] = exports.OFFICE_365_CALENDAR_ID,
    _a[exports.APPLE_CALENDAR_TYPE] = exports.APPLE_CALENDAR_ID,
    _a[exports.ICS_CALENDAR_TYPE] = exports.ICS_CALENDAR_ID,
    _a[exports.GOOGLE_MEET_TYPE] = exports.GOOGLE_MEET_ID,
    _a);
